import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import { compose } from "redux";
import { connect } from "react-redux";

import { LoanTypeLinkList, CloneValuesInputButton } from "..";

import "./styles.css";
import { SecondaryButton } from "components/Global/Buttons";

import CompanyModal from "../CompanyModal/CompanyModal";
import { loanProceedsRecalculate } from "../LoanProceedsSettings/LoanProceedsSettings.store";

const Header = ({ loanProceedsRecalculate, authentication, selectedLoanType, setSelectedLoanType, handleClonePress, defaultValuesDisabled, ...formikProps }) => {
  const [isOpen, setOpen] = useState(false);
  const [isProTier, setIsProTier] = useState(false);
  const { isSystemAdmin } = authentication;
  const recalculateAll = () => loanProceedsRecalculate({});
  const recalculate = companyId => loanProceedsRecalculate({ companyId });

  useEffect(() => {
    setIsProTier(authentication?.companyLevel !== "Not subscribed");
  }, [authentication]);

  return (
    <Grid container style={{ alignItems: "center" }} xs={12}>
      <Grid container item xs={9}>
        <Grid item xs={12}><h1 className="loan-proceeds-settings-header-text">Loan Proceeds Settings</h1></Grid>
        <Grid item xs={12}><LoanTypeLinkList selectedLoanType={selectedLoanType} setSelectedLoanType={setSelectedLoanType} /></Grid>
      </Grid>
      {isSystemAdmin && <Grid item xs={3}>
        <SecondaryButton
          onClick={() => {
            recalculateAll();
          }}
        >
          Recalculate All Portfolios
        </SecondaryButton>
        <SecondaryButton
          onClick={() => {
            setOpen(true);
          }}
        >
          Recalculate Single Portfolio
        </SecondaryButton>
        {Boolean(isProTier) && <CloneValuesInputButton {...formikProps} handleClonePress={handleClonePress} disabled={defaultValuesDisabled} />}
        <CompanyModal isOpen={isOpen} onClose={() => setOpen(false)} onSubmit={recalculate} />
                        </Grid>}
    </Grid>
  );
};

const mapStateToProps = ({ authentication }) => ({ authentication });

export default compose(connect(mapStateToProps, { loanProceedsRecalculate }))(Header);
